import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { FloatingElement } from '../../../../components/SearchForm/components/WidgetOverlay/components/FloatingElement.js';
import { Drawer } from '../../../../primitives/index.js';
export const WidgetOverlay = ({
  open,
  type,
  children,
  dim = false
}) => {
  if (type === 'drawer') {
    return _jsx(Drawer, {
      open: open,
      anchor: "right",
      fullWidth: true,
      children: children
    });
  }
  return _jsx(FloatingElement, {
    dim: dim,
    open: open,
    children: children
  });
};